export default "__VITE_ASSET__CzBxpieN__"